<template>
  <div v-if="order != null" class="point_confirm">
    <section class="text_center">
      <h2 class="header_underline">BitCash決済確認</h2>
      <p>購入内容</p>
      <table class="table white brown">
        <tr>
          <th>決済金額</th>
          <th>追加ポイント</th>
        </tr>
        <tr>
          <td>{{ order.price.toLocaleString() }}円</td>
          <td>{{ order.point }}pt</td>
        </tr>
      </table>
      <form
        action=""
        method="post"
        class="form"
      >
        <div>
          <p>
            <button
              type="submit"
              class="btn arrow"
              :disabled="isSend"
              @click="submit"
            >決済する</button>
          </p>
          <div class="caution">
            <p class="text_left font_annotation--text">上記ご確認の上、「決済する」を押してください。</p>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import { GET_BITCASH_PREPARE } from '@/store/point/actions'

export default {
  name: 'PointBitcashConfirm',
  props: {
    order: Object
  },
  data () {
    return {
      isSend: false
    }
  },
  methods: {
    submit () {
      this.isSend = true
      this.getBitcashPrepare()
    },
    getBitcashPrepare () {
      this.$store.dispatch(GET_BITCASH_PREPARE, {
        id: this.order.id
      })
        .then((data) => {
          // エラーの場合メッセージがあるのでユーザへアラート
          if ('message' in data) {
            if (!alert(data.message)) {
              window.location = data.redirect_url
            }
          } else {
            window.location = data.redirect_url
          }
        })
        .catch((error) => {
          if (!alert(error.message)) {
            this.$router.pushIsses({ name: 'PointBitcashForm' })
          }
        })
    }
  },
  created () {
    if (this.order == null) {
      this.$router.go(-1)
    }
  }
}
</script>
